<template>
  <div class="positionList pages">

    <el-header>
      <div class="pageTitle">
        <h3>Position List</h3>
        <el-button type="success"
                   style="float:right;margin-top:-20px;"
                   @click="add(0)">Create Position</el-button>
      </div>
      <!-- <h3 class="pageTitle">Position List</h3> -->
      <el-row type="flex"
              class="condition"
              justify="space-between">
        <el-col :span="8">
          <div class="username filterContent">
            <span class="label_name">Position</span>
            <el-input :placeholder="`Enter UC Position`"
                      v-model="searchInfo.keyword">
              <i slot="suffix"
                 class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="_btnCnt filterContent">
            <el-button type="primary"
                       @click="query">Search</el-button>
            <el-button type="primary"
                       @click="resetCon">Clear</el-button>

          </div>
        </el-col>
        <!-- <el-col :span="4">
          <div class="_btnCnt filterContent">
            <el-button type="primary"
                       @click="add(0)">Create Position</el-button>
          </div>
        </el-col> -->
      </el-row>

    </el-header>
    <el-main class="table">
      <x-table ref="mt"
               :tableData="tableData"
               :key="$route.fullPath + new Date()"
               :tabheight="tabheight"
               :tableHeader="tableHeader"
               :loading="loading"></x-table>

      <x-pagination @pageChanged="onPageChanged"></x-pagination>
    </el-main>

    <!-- 
    <my-dialog :myVisible="addDept"
               @changes="changes"
               @dialogSure="dialogSure"
               :title="title">

      <template v-slot:content>
  
      </template>

    </my-dialog> -->
  </div>
</template>

<script>
import xTable from "@/components/x-table.vue";
import xPagination from "@/components/pagination/index.vue";
import pagination from "@/components/pagination/index.js";
import { getJoblist, jobSave, jobDel } from "@/api/api.js";
var inputValidator = function (val) {
  if (val.length < 1 || val.length > 30) {
    return false;
  } else if (new RegExp("[\\u4E00-\\u9FFF]+", "g").test(val)) {
    return false;
  }
  return true;
};
export default {
  name: "positionList",
  components: { xTable, xPagination },
  mixins: [pagination],
  data() {
    return {
      loading: false,
      isshow: false,
      tabheight: "100%",
      tableData: [],
      searchInfo: {
        keyword: ""
      }
    };
  },
  computed: {
    tableHeader() {
      return [
        { prop: "id", label: "ID", width: "80px" },
        {
          prop: "name",
          label: `Position name`
        },

        {
          prop: "status",
          label: `status`,
          width: "150px",
          formatData: function (val) {
            return val == 1
              ? `<strong style="color: #31a354">Active</strong>`
              : `<strong style="color: #F56C6C">Locked</strong>`;
          }
        },
        {
          prop: "updated_at",
          label: `Date Updated`,
          width: "250px"
          //   width: "100px"
        },
        {
          prop: "created_at",
          label: `Date Created`,
          width: "250px"
          //   width: "100px"
        },
        {
          prop: "oper",
          label: `Action`,
          fixed: "right",
          width: "200px",
          oper: [
            {
              name: `Delete`,
              style: "danger",
              clickFun: this.delClick
            },
            {
              name: `Modify`,
              style: "primary",
              type: 2,
              clickFun: (e) => {
                this.add(e);
              }
            }
          ]
        }
      ];
    }
  },
  methods: {
    query() {
      const params = this.addPageInfo(this.searchInfo);
      this.loading = true;
      getJoblist(params).then((res) => {
        this.tableData = res.list;
        this.onGotPageData(res);
        this.loading = false;
      });
    },
    resetCon() {
      this.pagination.page = 1;
      this.searchInfo = {
        keyword: ""
      };
    },
    add(type) {
      let title = !type ? "Create" : "Modified";
      this.$prompt("Position name", `${title} Position`, {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        inputValue: !type ? " " : type.name,
        inputValidator: inputValidator,
        inputErrorMessage: "Incorrect naming format"
      })
        .then(({ value }) => {
          let id = !type ? 0 : type.id;
          let data = { id: id, name: value };
          jobSave(data).then(() => {
            this.$message({
              type: "success",
              message: `Position  ${title}  successfully`
            });
            this.query();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Cancel Edit"
          });
        });
    },
    delClick(e) {
      console.log(e);
      this.$confirm(`Delete ${e.name} Position?`, "Delete Position", {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        type: "warning"
      })
        .then(() => {
          let data = { id: e.id, name: e.name };
          jobDel(data).then(() => {
            this.$message({
              type: "success",
              message: "Delete successful!"
            });
            this.query();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Cancel Delete"
          });
        });
    },
    checkPosition() {}
  },
  mounted() {
    this.query();
  }
};
</script>

<style scoped lang="less">
.positionList {
  .el-header {
    height: auto !important;
    border-bottom: 1px dashed #909399;
    padding: 0;
  }
  .condition {
    margin-top: 20px;
  }
  .label_name {
    padding-right: 5px;
    width: 86px;
    box-sizing: border-box;
    display: inline-block;
  }
  .filterContent {
    margin-bottom: 15px;
    // margin-right: 20px;
  }
  .el-input,
  .el-select {
    width: 240px;
  }

  ._btnCnt {
    float: right;
    // width: 326px !important;
    height: 30px;
    button {
      min-width: 70px;
    }
  }
}
</style>
